'use strict';
import { cn_roof_opening } from '../model/cn_roof_opening';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_svg_map } from './cn_svg_map';
import { cn_clone } from '../utils/cn_utilities';
import { cn_type_pastille } from './cn_type_pastille';
import { cn_edit_box } from './cn_edit_box';
import { cn_pastille } from './cn_pastille';
import { cn_number_input, cn_number_list_input } from './cn_inputs';
import { cn_rectangle_handler } from './cn_rectangle_handler';

export class cn_roof_opening_handler extends cn_edition_handler {
    //***********************************************************************************
    /**
     * Constructor
     * @param {Array<cn_roof_opening>} openings
     * @param {cn_svg_map} map
     * @param {boolean} creation
     */
    constructor(openings, map, creation = false) {
        super(openings, map);
        const obj = this;

        this._map = map;
        this._scene = this._map._scene;
        this._transaction_manager = this._map._building.transaction_manager;

        this._openings = openings;
        this._opening = (openings.length == 1) ? openings[0] : null;
        this._edited_opening_mouseover = false;

        //*** Rotation handler : only for single selection */
        this._rotation_handler = null;
        if (this._opening) {
            this._rotation_handler = new cn_rectangle_handler([0, 0], [1, 1], 0, this);
            this._rotation_handler.min_size = [0.1, 0.1];
            this._rotation_handler.on('change', () => {
                this._transaction_manager.push_transaction('Modification d\'ouvrant de toiture', obj._opening.ID);
                this._transaction_manager.push_item_set(this._opening, ['position', 'width', 'length', 'orientation'], item => {
                    item.update();
                });
                this._opening.position = cn_clone(this._rotation_handler.center);
                this._opening.orientation = this._rotation_handler.orientation;
                if (this._opening.get_width() != this._rotation_handler.size[0])
                    this._opening.width = this._rotation_handler.size[0];
                if (this._opening.get_length() != this._rotation_handler.size[1])
                    this._opening.length = this._rotation_handler.size[1];
            });
            this._rotation_handler.on("measure_clicked", () => this._select_opening_dimensions());
            this._handlers.push(this._rotation_handler);
        }

        //*** Edit box for mass selection */
        const edit_box = new cn_edit_box(this, openings, this._readOnly);
        this._handlers.push(edit_box);

        if (!this._readOnly) {

            //*** Dimensions pastille */
            const dimensions_pastille = new cn_pastille([0, 0], 'tape_measure.svg');
            edit_box.add_pastille(dimensions_pastille);
            dimensions_pastille.svg_class = 'pastille_background white';
            dimensions_pastille.title = 'Dimensions';
            dimensions_pastille.clicked = () => {
                this._select_opening_dimensions();
            }

            //*** Type pastille */
            const type_pastille = new cn_type_pastille(openings, 'opening_type', () => map._building.get_roof_opening_types(), 'Type de baie', map);
            type_pastille.title = `Modifier le modèle de l'ouvrant`;
            edit_box.add_pastille(type_pastille);
            type_pastille.checkbox_label = "Conserver les dimensions";
            type_pastille.on("clicked", () => {
                type_pastille.checkbox_status = false;
                openings.forEach(opening => opening["old_opening_type"] = opening.opening_type);
            });
            type_pastille.on("callback", () => {
                openings.forEach(opening => {
                    this._transaction_manager.push_item_set(opening, ["width", "length"]);
                    if (type_pastille.checkbox_status) {
                        if (opening.width < 0) opening.width = opening["old_opening_type"].width;
                        if (opening.length < 0) opening.length = opening["old_opening_type"].length;
                    }
                    else {
                        opening.width = -1;
                        opening.length = -1;
                    }
                });
            });
        }

        edit_box.add_select_siblings_pastille('opening_type');
        edit_box.add_information_pastille('opening_type');

    }

    _select_opening_dimensions() {

        const input_list = [];

        const input_width = new cn_number_input('Largeur', this._openings[0].get_width(), 'm', 2, 0.1, 10);
        const variable_width = this._openings.some(s => s.width != this._openings[0].width);
        input_width.checkbox_label = (variable_width) ? "Variable" : "Automatique";
        input_width.checkbox_status = (variable_width || (this._openings[0].width < 0));
        input_list.push(input_width);

        const input_length = new cn_number_input('Longueur', this._openings[0].get_length(), 'm', 2, 0.1, 10);
        const variable_length = this._openings.some(s => s.length != this._openings[0].length);
        input_length.checkbox_label = (variable_length) ? "Variable" : "Automatique";
        input_length.checkbox_status = (variable_length || (this._openings[0].length < 0));
        input_list.push(input_length);

        const input = new cn_number_list_input('Dimensions', input_list);
        input.callback = () => {
            this._transaction_manager.push_transaction('Dimensions de baies');
            this._openings.forEach(opening => {
                this._transaction_manager.push_item_set(opening, ['width', 'length']);
                if (!variable_width)
                    opening.width = (input_width.checkbox_status) ? -1 : input_width.value;
                else if (!input_width.checkbox_status)
                    opening.width = input_width.value;

                if (!variable_length)
                    opening.length = (input_length.checkbox_status) ? -1 : input_length.value;
                else if (!input_length.checkbox_status)
                    opening.length = input_length.value;

            });
            this._map.refresh();
        };
        this._map.call('number_list_input', input);
    }

    //***********************************************************************************
    //**** Draws
    //***********************************************************************************
    draw(camera) {
        let html = "";

        if (this._opening) {
            var draw_extras = ['selected'];
            if (this._edited_opening_mouseover) draw_extras.push('mouseover');
            html += this._opening.draw(camera, draw_extras);
        }

        if (this._rotation_handler) {
            this._rotation_handler.center = cn_clone(this._opening.position);
            this._rotation_handler.size = [this._opening.get_width(), this._opening.get_length()];
            this._rotation_handler.orientation = this._opening.orientation;
            this._rotation_handler.set_rotation_snap_segments((this._opening.slab) ? this._opening.slab.get_segments() : []);
        }
        html += super.draw(camera);

        return html;
    }

}

